import ContactUsForm from "@/components/actions/form/ContactUsForm";
import PageBanner from "@/components/carousel/PageBanner";
import ContactInformation from "@/components/data-display/card/ContactInformation";
import LocationUrlCard from "@/components/data-display/card/LocationUrlCard";
import MetaData from "@/components/seo/MetaData";

function ContactUs() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/contact-us`;

  return (
    <>
      <MetaData url={pageUrl} />
      <PageBanner bannerText="Contact Us" />

      <div className="md:mt-[4rem] mt-[3rem] px-[1.25rem] md:px-[4rem] lg:px-[12.375rem]">
        <div className="flex flex-col gap-[3rem] md:flex-row ">
          <div className="w-full lg:w-[60%]">
            <ContactUsForm />
          </div>
          <div className="md:mt-[6rem]">
            <ContactInformation />
          </div>
        </div>
        <div className="mb-[5.68rem] mt-[4rem]">
          <LocationUrlCard />
        </div>
      </div>
    </>
  );
}

export default ContactUs;
